'use client';

import { c as _c } from "react/compiler-runtime";
import { H3 } from '@algoacademy/design-system/web/typography/Heading';
import { P2 } from '@algoacademy/design-system/web/typography/Paragraph';
type OfferFormHeaderProps = {
  isChangeMode: boolean;
  chosenTermsSummary: string;
};
export function OfferFormHeader(t0) {
  const $ = _c(9);
  const {
    isChangeMode,
    chosenTermsSummary
  } = t0;
  const t1 = isChangeMode ? "Zmie\u0144 ustawienia mentoringu" : "Wystaw ofert\u0119";
  let t2;
  if ($[0] !== t1) {
    t2 = <H3>{t1}</H3>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = chosenTermsSummary[0][0];
  let t4;
  if ($[2] !== chosenTermsSummary) {
    t4 = chosenTermsSummary.slice(1).toLowerCase();
    $[2] = chosenTermsSummary;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = t3 + t4;
  let t6;
  if ($[4] !== t5) {
    t6 = <P2 className="text-contentSecondary">{t5}</P2>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t2 || $[7] !== t6) {
    t7 = <div className="flex flex-col gap-1">{t2}{t6}</div>;
    $[6] = t2;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
}